import FJConfig from "../config/FJConfig";
import FJNetworkStore from "./FJNetworkStore";
import FJCoreConstant from "../core/constant/FJCoreConstant";
import FJUtil from "../util/FJUtil";
import FJTheNounProject from './FJTheNounProject'
import FJMessageStore from "./FJMessageStore";
import FJLocalStore from "./FJLocalStore";
import FJViewConstant from "../constant/FJViewConstant";

/**
 * @description 元素管理器（widget、静态svg）
 */
export default (function () {

  let _dataStore = null;
  let _list = null;
  let _history = localStorage.getItem('searchHistoryForWidget');
  let _searchHistory = _history ? JSON.parse(_history) : [];
  return {
    /**
     * @description 初始化元素数据
     * @return {Promise<void>}
     */
    init: async function () {
      let list = await FJNetworkStore.fetchResourceAsync(FJConfig.resourceDataPath);
      if (list) {
        list.intro = [
          {name: 'NO_INTRO', localName: 'no-intro', type: 'intro'},
          ...list.intro,
        ]
        _list = list;
      } else {
        throw new Error('fetch element list failed');
      }
    },

    /**
     * @description 返回所有的元素数据
     * @return {null}
     */
    getList: function () {
      return _list;
    },

    /**
     * @description 返回所有的入场小组件
     */
    getIntroList: function () {

    },

    /**
     * @description 返回所有的元素的实际数据
     * @return {null}
     */
    getAllElementData: function () {
      return _dataStore;
    },

    /**
     * @description 根据名字、类型获取分类
     * @param name
     * @param type
     * @return {string}
     */
    getCategoryByName: function (name, type) {
      let cate = '';
      let data = _list.data;
      for (let i = 0; i < data.length; i++) {
        let {category, list} = data[i];
        if (list.find(l => l.name.toLowerCase() === name.toLowerCase() && l.type === type)) {
          cate = category;
          break;
        }
      }
      return cate;
    },

    /**
     * @description 获取元素的实际数据
     * @param type
     * @param name
     * @param options
     * @param options.fromType
     */
    getElementData: async function (type, name, options) {
      let {elementDataPath, version} = FJConfig;
      let {SVG_LOCAL, SVG_WEB} = FJViewConstant;
      let _fromType = (options && options.fromType) || FJViewConstant.SVG_LOCAL;
      _dataStore = _dataStore || {};
      if (_dataStore[name]) {
        return type === FJCoreConstant.SVG ? FJUtil.cloneNodeSync(_dataStore[name]) : _dataStore[name];
      } else {
        let data;
        if (type === FJCoreConstant.SVG) {
          switch (_fromType) {
            case SVG_LOCAL:
              data = await this.fetchLocalSvg(name);
              break;
            case SVG_WEB:
              data = await this.fetchWebSvg(name);
              break;
            default:
          }
        } else {
          let path = `${elementDataPath}/${name}.json?v=${version}`;
          data = await FJNetworkStore.fetchResourceAsync(path, 'json');
        }
        if (data) {
          _dataStore[name] = data;
        }
        return type === FJCoreConstant.SVG ? FJUtil.cloneNodeSync(_dataStore[name]) : _dataStore[name];
      }
    },

    fetchLocalSvg: async function (name) {
      let {staticSvgPath, version} = FJConfig;
      let path = `${staticSvgPath}/${this.getCategoryByName(name)}/${name}.svg?v=${version}`;
      let data = await FJNetworkStore.fetchResourceAsync(path, 'text');
      return FJUtil.decodeSvg(data) && FJUtil.cloneNodeSync(FJUtil.decodeSvg(data));
    },

    fetchWebSvg: async function (name) {
      let svg = await FJTheNounProject.fetchByID(name);
      return svg && FJUtil.cloneNodeSync(svg);
    },

    /**
     * @description 根据tag进行
     * @param value
     * @return {this}
     */
    searchByTag: function (value) {
      let result = [];
      let keyword = value.toLowerCase();
      keyword = keyword.replace(/ +/g, ' ').replace(/ +$|(^ +)/g, '');
      let keywords = keyword.split(' ');
      _list.data.forEach(item => {
        let list = item.list;
        list.forEach((data) => {
          let power = 0;
          let name = data.name.replace(/\-/g, ' ');
          let tag = data.tag;
          if (!tag)
            tag = [];
          let tmp = [...new Set([
            ...name.split(' '),
            ...tag
          ])];
          tmp.push(item.category);
          keywords.forEach(key => {
            if (key !== "and" && key !== "with" && key !== "or" && key !== "of" && key !== "the" &&
              key !== "by" && key !== "on" && key !== "to" && key !== "in") {
              if (-1 !== tmp.indexOf(key)) {
                power += 1;
              }
            }
          });
          if (power > 0) {
            result.push({...data, category: item.category, power: power});
          }
        });
      });
      return result.sort((a, b) => {
        if (a.power < b.power) {
          return 1;
        } else if (a.power === b.power) {
          return 0;
        } else {
          return -1;
        }
      });
    },

    /**
     * @description 从网络搜索
     * @param value
     * @return {Promise<void>}
     */
    searchFromWeb: async function (value) {

      let result = [];
      try {
        let data = await FJTheNounProject.search(value);
        if (data) {

          // 处理数据
          result = data.map(item => {
            return {
              elementType: FJCoreConstant.SVG,
              imageURL: item.icon_url,
              original: item.icon_url,
              id: item.id,
              svg: item.svg,
              name: item.id,
            };
          });
        }
      } catch (e) {
        console.log(e);
        FJMessageStore.addMessage(FJLocalStore._('network-error'), 'warning');
      }

      return result;
    },

    nextPage: async function () {
      let result = [];
      let data = await FJTheNounProject.nextPage();
      if (data) {

        // 处理数据
        result = data.map(item => {
          return {
            elementType: FJCoreConstant.SVG,
            imageURL: item.icon_url,
            original: item.icon_url,
            id: item.id,
            svg: item.svg,
            name: item.id,
          };
        });
      }

      return result;
    },

    allSearchHistory: function () {
      return _searchHistory.slice(0,10);
    },

    addSearchHistory: function (value) {
      if (!_searchHistory.includes(value)) {
        _searchHistory.unshift(value);
      } else {
        _searchHistory.splice(_searchHistory.indexOf(value), 1);
        _searchHistory.unshift(value);
      }
      localStorage.setItem('searchHistoryForWidget', JSON.stringify(_searchHistory));
    },

    clearSearchHistory: function () {
      _searchHistory = [];
      localStorage.setItem('searchHistoryForWidget', JSON.stringify([]));
    },
  }
})();